import { saveExportAudience, fetchExportJobDetails } from '@/features/AudienceManager/data';
const audienceManagerExportation = {
    namespaced: true,
    state: {
        batchId: '',
        progressBar: 0,
        showModal: {
            success: false,
            error: false,
            progress: false,
            preview: false,
        },
        resultCode: '',
        activateExportationAudienceModal: false,
    },
    getters: {
        activeStep: state => state.activeStep,
        progressBar: state => state.progressBar,
        resultCode: state => state.resultCode,
        activateExportationAudienceModal: state => state.activateExportationAudienceModal,
        batchId: state => state.batchId,
    },
    actions: {
        setShowExportError({ dispatch, commit }) {
            dispatch('setFinalizeExport');
            setTimeout(() => commit('UPDATE_VISIBILITY_MODAL', { type: 'error', value: true }), 300);
        },
        setFinalizeExport({ commit }) {
            setTimeout(() => commit('UPDATE_VISIBILITY_MODAL', { type: 'progress', value: false }), 1000);
            setTimeout(() => commit('ACTIVATE_EXPORTATION_AUDIENCE_MODAL', false), 1000);
        },
        saveExportAudience({ commit, dispatch, rootState }, selectedColumnsKeys) {
            commit('UPDATE_VISIBILITY_MODAL', { type: 'progress', value: true });
            const audienceId = rootState.audienceManager.audienceId;
            saveExportAudience(audienceId, selectedColumnsKeys)
                .then(data => {
                if (!data)
                    return;
                commit('SET_BATCH_ID', data.batchId);
                commit('UPDATE_PROGRESS_BAR', 0);
                dispatch('fetchExportationStatus');
            })
                .catch(() => {
                dispatch('setShowExportError');
            });
        },
        fetchExportationStatus({ state, dispatch, commit }) {
            if (!state.batchId)
                return;
            fetchExportJobDetails(state.batchId)
                .then(data => {
                const result = data.result;
                commit('SET_RESULT_CODE_EXPORT', result.code);
                commit('UPDATE_PROGRESS_BAR', result.progress);
                const errorCodes = ['job-cancelled-with-errors', 'clickhouse-select-fail'];
                if (!result || result.code === 'job-cancelled-by-user') {
                    dispatch('setFinalizeExport');
                    return;
                }
                if (errorCodes.includes(result.code)) {
                    dispatch('setShowExportError');
                    return;
                }
                if (result.code === 'no-results-found') {
                    dispatch('setFinalizeExport');
                    return;
                }
                commit('UPDATE_VISIBILITY_MODAL', { type: 'progress', value: true });
                if (!result.url) {
                    setTimeout(() => dispatch('fetchExportationStatus'), 3000);
                }
                else {
                    const link = document.createElement('a');
                    link.href = result.url;
                    link.download = '';
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    setTimeout(() => {
                        commit('UPDATE_VISIBILITY_MODAL', { type: 'progress', value: false });
                        commit('UPDATE_VISIBILITY_MODAL', { type: 'success', value: true });
                        commit('SET_BATCH_ID', '');
                    }, 1000);
                }
            })
                .catch(() => {
                dispatch('setShowExportError');
            });
        },
    },
    mutations: {
        SET_BATCH_ID(state, batchId) {
            state.batchId = batchId;
        },
        UPDATE_PROGRESS_BAR(state, value) {
            state.progressBar = value;
        },
        UPDATE_VISIBILITY_MODAL(state, { type, value }) {
            state.showModal[type] = value;
        },
        ACTIVATE_EXPORTATION_AUDIENCE_MODAL(state, isVisible) {
            state.activateExportationAudienceModal = isVisible;
        },
        SET_VISIBILITY_MODAL(state, isVisible) {
            state.isVisible = isVisible;
        },
        SET_RESULT_CODE_EXPORT(state, resultCode) {
            state.resultCode = resultCode;
        },
    },
};
export default audienceManagerExportation;
